import { MenuResource } from '@menu/Types/Resources/MenuResource';
import getRestaurant from '@menu/Utils/getRestaurant';

export default (menuSlug: string): MenuResource => {
  const menu = getRestaurant().menus.find(({ slug }) => slug === menuSlug);

  if (!menu) {
    throw new Error(`Menu not found by slug: ${menuSlug}`);
  }

  return menu;
};
